// extracted by mini-css-extract-plugin
export default {"rights":"Footer_rights__HH8zu"};